import { useContext } from '@berlin-front/common/composables/context';
import { computed, reactive } from '@vue/composition-api';
import { ApiCacheContext } from '@/services/ApiCacheContext';
import { hasProps, isString, windowOpenNewTab } from '@berlin-front/common/utils';
import { broadcast } from '@/broadcast';
import { AuthNgFailContextType } from './composable';
import NpAtobaraiNgDetailVue from './detail-link/NpAtobaraiNgDetail.vue';

const npAtobaraiAuthNgFailContext: AuthNgFailContextType = {
  useAuthNgFail: () => {
    const { registTransactionPostResult } = useContext(ApiCacheContext);

    const authorizationResultNgMessage = computed(() =>
      hasProps(registTransactionPostResult, 'value.authorizationResultNgMessage', isString)
        ? registTransactionPostResult.value.authorizationResultNgMessage.split(/[\r\n]+/).filter((v) => v)
        : [],
    );

    const onCancel = () => {
      broadcast.send({
        type: 'MODAL_CONTROL_FAILED',
        payload: {
          serviceType: '02',
        },
      });
    };

    const onInquiry = () => {
      windowOpenNewTab(process.env.VUE_APP_NP_ATOBARAI_SETTLEMENT_ERROR_DETAIL_URL);
    };

    return reactive({
      // 表示項目
      ngReasons: authorizationResultNgMessage,

      detailComponent: NpAtobaraiNgDetailVue,

      // 関数,
      onCancel,
      onInquiry,
    });
  },
};

export default npAtobaraiAuthNgFailContext;
